import {Flex, Box, Text, Skeleton} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import withProviders from '~/react/contexts/withProviders'
import {NextScreenHeader as ScreenHeader} from '~/react/components/ScreenHeader'
import BackgroundPatternImage from '../../../assets/images/background_pattern_image.svg'
import {usePointsBalance} from '../../hooks/usePointsBalance'
import {OnboardingStepper} from '../../components/OnboardingStepper'
import {MostRecentTransactions} from '../../components/MostRecentTransactions'
import {useStepperData} from '../../components/OnboardingStepper/useStepperData'
import {useDashboardData} from './useDashboardData'

const DashboardScreen = () => {
  const {t} = useTranslation('points')

  const {pointsBalance, loading: loadingBalance} = usePointsBalance()
  const {data, loading, refresh} = useDashboardData()
  const {supplierDisplayName: name, stepperData} = data || {}
  const {completed} = useStepperData(stepperData || {})

  return (
    <>
      <ScreenHeader
        text={t('dashboardScreen.title', {name})}
        isLoaded={!loadingBalance}
        className="fs-unmask"
      />
      <Box
        bgGradient="linear(to-r, mld.primary.400, mld.primary.100)"
        borderColor="mld.primary.400"
        borderRadius="lg"
      >
        <Box
          backgroundImage={`url(${BackgroundPatternImage})`}
          backgroundPosition="left 7%"
          backgroundRepeat="no-repeat"
          backgroundSize="140%"
          p="md"
          borderRadius="lg"
        >
          <Text
            textStyle={{base: 'headline5', sm: 'headline4'}}
            textTransform="uppercase"
            pb="xxs"
          >
            {t('dashboardScreen.balance.title')}
          </Text>
          <Flex
            justifyContent="space-between"
            alignItems="end"
            gap="sm"
            flexWrap="wrap"
          >
            <Skeleton
              isLoaded={!loadingBalance}
              startColor="mld.primary.70"
              endColor="mld.neutral.100"
            >
              <Text
                textStyle={{base: 'headline3', sm: 'headline2'}}
                whiteSpace="nowrap"
                className="fs-mask"
              >
                {pointsBalance.toLocaleString()}{' '}
                {t('common:marmaladeRewardCurrency')}
              </Text>
            </Skeleton>

            <Text textStyle="body-copy">
              {t('dashboardScreen.balance.headline', {
                context: completed ? 'completed' : null,
              })}
            </Text>
          </Flex>
        </Box>
      </Box>
      {!loading && (
        <Box p="md" borderRadius="lg" background="mld.neutral.0">
          <OnboardingStepper stepperData={stepperData} refresh={refresh} />
        </Box>
      )}
      <Box p="md" borderRadius="lg" background="mld.neutral.0">
        <MostRecentTransactions />
      </Box>
    </>
  )
}

export default withProviders(DashboardScreen)
